import { render, staticRenderFns } from "./chartTurnoverWeeks.vue?vue&type=template&id=fa9934d6&scoped=true&"
import script from "./chartTurnoverWeeks.vue?vue&type=script&lang=js&"
export * from "./chartTurnoverWeeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9934d6",
  null
  
)

export default component.exports